import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

const ImprintPage = () => (
  <Layout>
    <Seo title="Impressum" />
    <section className="container px-6 mx-auto mt-60 mb-20">
      <h2 className="text-5xl">Impressum</h2>
      <h3 className="mt-6 pb-2 text-2xl">Angaben gemäß § 5 TMG</h3>
      <p>
        Kim Kevin Brassel <br />
        Novus Hair & Colour Artists
        <br />
        Jägerstrasse 23
        <br />
        36329 Romrod
      </p>
      <h3 className="mt-6 pb-2 text-2xl ">Kontakt</h3>
      <p>
        Telefon: 01744188779 <br />
        E-Mail: info@novus-hair.de
      </p>
      <h3 className="mt-6 pb-2 text-2xl">
        Angaben zur Berufshaftpflichtversicherung
      </h3>
      <p>
        Name und Sitz des Versicherers: <br />
        SV SparkassenVersicherung Wiesbaden
        <br />
        Bahnhofstraße 69
        <br />
        65185 Wiesbaden
      </p>{" "}
      <br />
      <p>
        {" "}
        Geltungsraum der Versicherung:
        <br />
        Deutschland
      </p>
      <h3 className="mt-6 pb-2 text-2xl">EU-Streitschlichtung</h3>
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr.
        Unsere E-Mail-Adresse finden Sie oben im Impressum.
      </p>
      <h3>Verbraucher­streit­beilegung/Universal­schlichtungs­stelle</h3>
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>
      <h3 className="mt-6 pb-2 text-2xl">Haftung für Inhalte</h3>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf
        diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8
        bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
        übermittelte oder gespeicherte fremde Informationen zu überwachen oder
        nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
        hinweisen.
      </p>
      <p>
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
        Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
        Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
        Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
        entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
        entfernen.
      </p>
      <h3 className="mt-6 pb-2 text-2xl">Haftung für Links</h3>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
        Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
        waren zum Zeitpunkt der Verlinkung nicht erkennbar.
      </p>
      <p>
        Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch
        ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
        Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend
        entfernen.
      </p>
      <h3 className="mt-6 pb-2 text-2xl">Urheberrecht</h3>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
        sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
      </p>
      <p>
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
        werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
        Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Inhalte umgehend entfernen.
      </p>
    </section>
  </Layout>
)

export default ImprintPage
